var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenefitDistributions = function SvgBenefitDistributions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAD6CD",
    d: "M108.707 13.652v100.525c0 4.427-3.745 8.02-8.36 8.02h-74.58a8.6 8.6 0 0 1-2.106-.262c-3.6-.898-6.253-4.026-6.253-7.758V13.652c0-4.432 3.745-8.02 8.36-8.02h74.579c4.615 0 8.36 3.588 8.36 8.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M73.216 69.636c-9.049 0-16.384 7.164-16.384 16s7.335 16 16.384 16 16.384-7.163 16.384-16-7.336-16-16.384-16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M73.172 69.64v31.992h.044c9.049 0 16.384-7.163 16.384-16s-7.335-16-16.384-16h-.044z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "m68.023 94.226-1.103.719-2.82-4.329 4.432-2.887.698 1.07-2.412 1.571c2.176 1.175 5.324 1.239 8.032-.581 3.02-2.034 4.45-5.928 2.912-9.623l1.118-.728c1.215 2.624 1.24 6.4-1.234 9.49-2.475 3.096-7.05 4.678-11.322 2.69l1.695 2.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "m76.89 79.887 2.206-1.438.31.667c1.152 2.487 1.495 6.64-1.316 10.164a10.08 10.08 0 0 1-10.242 3.54l1.005 1.542-2.2 1.433-3.517-5.399 5.528-3.601 1.395 2.14-1.947 1.27c2.023.653 4.401.309 6.315-.989 2.92-1.963 4.017-5.6 2.67-8.835l-.205-.49zm1.61.475-.01.007c.187.544.319 1.098.396 1.648a8.8 8.8 0 0 0-.386-1.655M64.935 90.744l-.008.005 2.13 3.253zm3.328-2.168-2.883 1.878 1.163.538c2.904 1.351 5.762.912 7.95-.324-2.554 1.425-5.646 1.528-8.064.221l-.94-.507z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7789EF",
    d: "M45.696 107.923c4.458 0 8.07-3.529 8.07-7.881s-3.612-7.882-8.07-7.882c-4.457 0-8.07 3.529-8.07 7.882s3.613 7.881 8.07 7.881M30.72 122.548c0-8.079 6.708-14.625 14.976-14.625s14.976 6.55 14.976 14.625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M45.8 92.165h-.104c-4.457 0-8.07 3.528-8.07 7.881s3.613 7.882 8.07 7.882h.104V92.165"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4553A9",
    d: "M45.696 107.923c-8.273 0-14.976 6.55-14.976 14.625H45.8v-14.625zM118.261 72.7H82.615V24.576h35.646c5.965 0 10.809 4.84 10.809 10.81v26.509c0 5.965-4.84 10.809-10.809 10.809z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M82.585 72.7H49.721c-5.965 0-10.809-4.84-10.809-10.809V35.385c0-5.965 4.84-10.809 10.81-10.809h32.863z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFECB1",
    d: "M82.621 64.623c8.978 0 16.255-7.277 16.255-16.255 0-8.979-7.277-16.256-16.255-16.256S66.366 39.39 66.366 48.369s7.277 16.255 16.255 16.255"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD008",
    d: "M82.636 64.616c-8.979.007-16.263-7.255-16.27-16.234-.007-8.978 7.255-16.262 16.234-16.27"
  })));
};
export { SvgBenefitDistributions as Icon };
export default __webpack_public_path__ + "static/media/9bed4197851804657ccab6e959cfec25.svg";